<template>
    <div>
      <div class="stripe-elements" v-if="!paid">
        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <hr><br>
              <h5 class="text-center">{{ computeCaption(this.fields_en['payment_details'], this.$store.state.lang.value.toLowerCase()) }}</h5>
              <!-- Name -->
              <div class="group">
                <label for="cardHolderName">
                  <span class="card-label">{{ computeCaption(this.fields_en['name'], this.$store.state.lang.value.toLowerCase()) }}</span>
                  <input v-model="cardHolderName" id="card-name" class="field" placeholder="John Doe" name="cardHolderName"  onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }">
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <div class="group">
                <label for="card">
                  <span class="card-label">{{ computeCaption(this.fields_en['card'], this.$store.state.lang.value.toLowerCase()) }}</span>
                  <card-number class='stripe-element card-number field pt-10'
                               ref='cardNumber'
                               :stripe="publicKey"
                               :options="stripeOptions"
                               @change='number = $event.complete'
                  />
                </label>
              </div>
              <small id="card-errors" role="alert" v-text="computeCaption(errorMessage, $store.state.lang.value.toLowerCase())">{{ computeCaption(errorMessage, $store.state.lang.value.toLowerCase()) }}</small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-5 col-md-offset-1">
            <div class="form-group">
              <div class="group">
                <label for="card">
                  <span class="card-label">{{ computeCaption(this.fields_en['valid'], this.$store.state.lang.value.toLowerCase()) }}</span>
                  <card-expiry class='stripe-element card-expiry field pt-10'
                               ref='cardExpiry'
                               :stripe='publicKey'
                               :options='stripeOptions'
                               @change='expiry = $event.complete'
                  />
                </label>
              </div>
              <small id="card-errors" role="alert" v-text="computeCaption(errorMessage, $store.state.lang.value.toLowerCase())"></small>
            </div>
          </div>
          <div class="col-md-5">
            <div class="form-group">
              <div class="group">
                <label for="card">
                  <span class="card-label">{{ computeCaption(this.fields_en['cvc'], this.$store.state.lang.value.toLowerCase()) }}</span>
                  <card-cvc class='stripe-element card-cvc field pt-10'
                            ref='cardCvc'
                            :stripe='publicKey'
                            :options='stripeOptions'
                            @change='cvc = $event.complete'
                  />
                </label>
              </div>
              <small id="card-errors" role="alert" v-text="computeCaption(errorMessage, $store.state.lang.value.toLowerCase())"></small>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <div class="form-group">
              <div class="group">
                <label for="cardZip">
                  <span class="card-label">{{ computeCaption(this.fields_en['zip'], this.$store.state.lang.value.toLowerCase()) }}</span>
                  <input name="cardZip"
                         ref='cardZip'
                         class='field'
                         v-model="cardZip"
                         oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);"
                         type="number"
                         maxlength="5"
                         onkeydown="if (arguments[0].code === undefined) { return false} if (arguments[0].code.includes(['Space']) && arguments[0].target.value === '') { return false }"
                  />
                </label>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 col-md-offset-1">
            <small id="card-errors" role="alert" v-text="computeCaption(errorCardHolderName, $store.state.lang.value.toLowerCase())">{{ computeCaption(errorCardHolderName, $store.state.lang.value.toLowerCase()) }}</small>
          </div>
        </div>
        <br>
      </div>
      <div v-else>
        <div class="col-md-10 col-md-offset-1">
          <div class="form-group">
            <h5 class="text-center">{{ computeCaption(this.fields_en['payment_received'], this.$store.state.lang.value.toLowerCase()) }}. <br>{{ computeCaption(this.fields_en['check_email'], this.$store.state.lang.value.toLowerCase()) }}!</h5>
            <h4 class="text-center">{{ computeCaption(this.fields_en['thank_you'], this.$store.state.lang.value.toLowerCase()) }}!</h4>
          </div>
        </div>
      </div>
    </div>
</template>

<script>
import {FormatterUtils} from '../../../../../../utils/Formatter'
import { CardNumber, CardExpiry, CardCvc, createToken } from 'vue-stripe-elements-plus'
import {SettingsUtils} from '../../../../../../utils/SiteConfigurations'
import {TranslationsUtils} from '../../../../../../utils/Translations'
import {PatientInfoUtils} from '../../../../../../utils/PatientInfo'

export default {
  mixins: [FormatterUtils, SettingsUtils, TranslationsUtils, PatientInfoUtils],
  components: {CardNumber, CardExpiry, CardCvc},
  props: ['paid'],
  data () {
    return {
      fields_en: {
        payment_details: 'Please provide your payment details',
        name: 'Name',
        card: 'Card',
        valid: 'Valid',
        cvc: 'CVC',
        zip: 'ZIP',
        payment_received: 'Your Payment Has Been Successfully Received',
        check_email: 'Please check your email for confirmation',
        thank_you: 'Thank you for your payment',
        registration_not_found: 'We couldn\'t find your registration'
      },
      errorCardHolderName: '',
      errorMessage: '',
      validationObject: {
        name: false,
        cardNumber: false,
        cardExpiry: false,
        cardCvc: false,
        cardZip: false
      },
      stripeOptions: {
        showIcon: true
      },
      cardHolderName: '',
      publicKey: this.$store.state.configs.STRIPE_PUBLIC_KEY,
      allowSitePayment: this.isTrue(this.$store.state.configs.ALLOW_SITE_PAYMENT),
      paymentMethod: 'card',
      disabled: false,
      number: false,
      expiry: false,
      cvc: false,
      cardZip: '',
      complete: false
    }
  },
  beforeMount () {
  },
  methods: {
    async validate () {
      if (this.cardHolderName === '') {
        document.getElementsByName('cardHolderName')[0].focus()
        this.$emit('validateSection', false)
        this.errorCardHolderName = 'Please fill in all the fields'
        return false
      }
      if (!this.number) {
        this.$refs.cardNumber.focus()
        this.$emit('validateSection', false)
        this.errorCardHolderName = 'Please fill in all the fields'
        return false
      }
      if (!this.expiry) {
        this.$refs.cardExpiry.focus()
        this.$emit('validateSection', false)
        this.errorCardHolderName = 'Please fill in all the fields'
        return false
      }
      if (!this.cvc) {
        this.$refs.cardCvc.focus()
        this.$emit('validateSection', false)
        this.errorCardHolderName = 'Please fill in all the fields'
        return false
      }
      if (!this.cardZip) {
        this.$refs.cardZip.focus()
        this.$emit('validateSection', false)
        this.errorCardHolderName = 'Please fill in all the fields'
        return false
      }
      if (this.cardHolderName && this.number && this.expiry && this.cvc && this.cardZip) {
        const result = await createToken({name: this.cardHolderName, address_zip: this.cardZip})
        if (result.token) {
          return result
        } else {
          return false
        }
      }
    },
    update () {
      this.complete = this.number && this.expiry && this.cvc
      // field completed, find field to focus next
      if (this.number) {
        if (!this.expiry) {
          this.$refs.cardExpiry.focus()
        } else
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else {
          if (!this.cardZip) {
            this.$refs.cardZip.focus()
          }
        }
      } else if (this.expiry) {
        if (!this.cvc) {
          this.$refs.cardCvc.focus()
        } else if (!this.number) {
          this.$refs.cardNumber.focus()
        }
      }
      // no focus magic for the CVC field as it gets complete with three
      // numbers, but can also have four
    }
  },
  watch: {
    'validationObject': {
      handler: function (val) {
        if (Object.values(val).every(field => field === true)) {
          this.$emit('validateSection', true)
        } else {
          this.$emit('validateSection', false)
        }
      },
      deep: true
    },
    'cvc': {
      handler: function (val) {
        if (val) {
          this.validationObject.cardCvc = true
        } else {
          this.validationObject.cardCvc = false
        }
      }
    },
    'cardZip': {
      handler: function (val) {
        if (val) {
          this.validationObject.cardZip = true
        } else {
          this.validationObject.cardZip = false
        }
      }
    },
    cardHolderName () {
      if (this.cardHolderName === '') {
        this.validationObject.name = false
        this.errorCardHolderName = 'Card Holder Name field cannot be empty'
      } else if (this.cardHolderName.length < 3) {
        this.validationObject.name = false
        this.errorCardHolderName = 'Card Holder Name field must be at least 3 characters'
      } else {
        this.validationObject.name = true
        this.errorCardHolderName = ''
      }
    },
    number () {
      if (this.number) {
        this.validationObject.cardNumber = true
      } else {
        this.validationObject.cardNumber = false
      }
      this.update()
    },
    expiry () {
      if (this.expiry) {
        this.validationObject.cardExpiry = true
      } else {
        this.validationObject.cardExpiry = false
      }
      this.update()
    }
    // cvc () { this.update() } if given a 3 digit number it would jump to the next section
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../../../assets/sass/paper/variables';
#card-errors{
  color: #f83f37;
}

.group {
  background: white;
  box-shadow: 0px 1px 3px #E7E8E9 !important;
  border-radius: 4px;
  border: 1px solid #DCDFE6;
}

label {
  position: relative;
  color: #31325F;
  font-weight: 300;
  height: 40px;
  line-height: 40px;
  margin-left: 20px;
  display: flex;
  flex-direction: row;
}

label > span {
  width: 80px;
  text-align: left;
}

.field {
  background: transparent;
  font-weight: 300;
  border: 0;
  color: #31325F;
  outline: none;
  flex: 1;
  padding-right: 10px;
  padding-left: 10px;
  cursor: text;
}

.pt-10{
  padding-top: 10px;
}

.radio-label{
  color: #474644;
  font-weight: bold;
  padding: 0;
  margin: 0;
}

.radio {
  margin: 0;
  margin-left: 10px;
}

.mt-6{
  margin-top: 6px;
}

.loading{
  margin-top: 30px;
}

.card-label {
  line-height: 14px;
  font-size: 14px;
  text-align: left;
  display: flex;
  align-items: center;
}

.stripe-elements label {
  margin-bottom: 0;
}

@media screen and (max-width: 550px) {
  label > span {
    width: 40px;
    text-align: left;
    margin-right: 10px;
  }
}

input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

/* Firefox */
input[type=number] {
  -moz-appearance: textfield;
}
</style>



// WEBPACK FOOTER //
// src/components/Dashboard/Views/Utils/SubComponents/PaymentParts/cardSectionStripe.vue